import { FaFilter } from "react-icons/fa";
import ExpenseCard from "./ExpenseCard";
import styled from "styled-components";
import { Utils } from "../../utils";
import { MdPayment } from "react-icons/md";

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 1rem;
`;

const Title = styled.div`
  font-weight: bold;
  color: #000000;
  font-size: 1.1rem;

  span {
    color: #28a745;
    margin-left: 0.3rem;
  }
`;

const ButtonGroup = styled.div<{ solid?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 6rem;

  button {
    border: 1px solid #28a745;
    background: ${(props) => (props.solid ? "#28a745" : "#ffffff")};
    color: ${(props) => (props.solid ? "#fff" : "#28a745")};
    padding: 0.4rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;

    &:first-child {
      border-color: #28a745;
      color: ${(props) => (props.solid ? "white" : "#28a745")};
    }
  }
`;


import { IoMdClipboard } from "react-icons/io";

const All = ({ data, showPay = false, onPay, refetchOwnExpenseClaims, openExpense }: any) => {
  return (
    <div style={{ maxWidth: "85%", margin: "auto" }}>
      <Header>
        <Title>
          All <span>({data.length})</span>
        </Title>
        {/* <ButtonGroup>
          <button style={{ minWidth: "6rem" }}>
            <FaFilter /> Filter
          </button>
        </ButtonGroup> */}
      </Header>

      {showPay && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <ButtonGroup solid>
            <button style={{ minWidth: "6rem" }} onClick={onPay} >
              <MdPayment /> Pay
            </button>
          </ButtonGroup>
        </div>
      )}

      <div>
        {data && data.length > 0 ? (
          data.map((item: any, index: any) => (
        <ExpenseCard
          key={item?.id}
          data={item}
          bgColor={
            Utils.LIGHT_COLOR_CODES[index % Utils.LIGHT_COLOR_CODES.length]
          }
          refetchOwnExpenseClaims={refetchOwnExpenseClaims} 
          openExpense={openExpense}
        />
          ))
        ) : (
          <div style={{ 
            textAlign: "center", 
            padding: "3rem 2rem", 
            color: "#666",
            fontSize: "1.1rem",
            fontWeight: "500"
          }}>
            <div style={{ marginBottom: "0.5rem",  }}>
              <IoMdClipboard size={28} />
            </div>
            No expenses claims found
            <div style={{ 
              fontSize: "0.9rem", 
              color: "#999", 
              marginTop: "0.5rem" 
            }}>
              Start by submitting a new expense claim.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default All;
